import React from 'react';
import { Box, PagePanel } from 'edenred-ui';

import { QuantityProps } from '@epi-models/components/Quantity';

import { VoucherQuantity } from '../../forms/VoucherQuantity/VoucherQuantity';
import { BenefitSummaryContent } from '../BenefitSummaryContent/BenefitSummaryContent';

export function Quantity({
  voucherTypeKey,
  vouchers,
  orderSummary,
  useCalculator = false,
  locale,
  header,
  maxOrderTotalAmount,
  voucherMinimumQuantity
}: QuantityProps) {
  return (
    <div className="page1">
      <PagePanel title={header}>
        <Box className="order-page-voucher-quantity">
          <VoucherQuantity
            voucherTypeKey={voucherTypeKey}
            vouchers={vouchers}
            useCalculator={useCalculator}
            locale={locale}
            maxOrderTotalAmount={maxOrderTotalAmount}
            voucherMinimumQuantity={voucherMinimumQuantity}
          />
        </Box>
        <hr />
        <Box className="order-page-benefit-summary" pt={2}>
          <BenefitSummaryContent
            voucherTypeKey={voucherTypeKey}
            orderSummary={orderSummary}
          />
        </Box>
      </PagePanel>
    </div>
  );
}
